import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusTopLeft24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconRadiusTopLeft24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.404 3.596H13.1a9.25 9.25 0 0 0-9.25 9.25v3.505a.75.75 0 0 1-1.5 0v-3.505c0-5.938 4.813-10.75 10.75-10.75h3.303a.75.75 0 0 1 0 1.5m4.5 8.255a1 1 0 1 1 0 2 1 1 0 0 1 0-2m1-3.372a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1 7.372a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-11 5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m3-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m4 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusTopLeft24);
